import { useDispatch } from 'react-redux';

import { setIsConfirmationModalOpen } from '@app/redux/updateBillCycle';

import { ManageBilling } from '../Billing';

const PayBill = (): JSX.Element => {
  const dispatch = useDispatch();
  dispatch(setIsConfirmationModalOpen(false));

  return <ManageBilling />;
};

export default PayBill;
